export default function SocialIssues() {
  const magneticIssues = [
    {
      icon: 'ri-drop-line',
      text: '물이 흐르면서 회전하는 임펠러 상단에 영구자석(4극)이 규칙적으로 회전합니다.'
    },
    {
      icon: 'ri-compass-3-line',
      text: '회전하는 영구자석은 리드 스위치(또는 MR 센서)의 온/오프 펄스를 발생시킵니다.'
    },
    {
      icon: 'ri-bug-line',
      text: '발생하는 펄스를 카운트하여 물의 흐름(즉, 유량)으로 변환합니다.'
    },
    {
      icon: 'ri-error-warning-line',
      text: '수도 계기가 외부에 있어 자석 부근의 리드 스위치(MR 센서)는 외부 자석에 의해 영향을 받아 오류를 발생시킵니다.'
    },
    {
      icon: 'ri-alert-line',
      text: '임펠러 자석에 외부 자석을 부착하면 수도미터 유량 계산이 중지되어 정상적으로 사용할 수 없게 됩니다.'
    }
  ];

  // Optional: defensive check to avoid rendering issues if data is malformed
  const safeIssues = Array.isArray(magneticIssues) ? magneticIssues : [];

  return (
    <section id="social-issues" className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block px-5 py-2 bg-teal-50 rounded-full mb-4">
            <span className="text-teal-600 text-sm md:text-base font-bold">Why Optical Sensor</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4">
            광센서 수도미터를 <span className="text-teal-600">사용해야 하는 이유</span>
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto"></div>
        </div>

        {/* 기존 자석식 수도미터기의 문제점 */}
        <div className="mb-12 md:mb-16">
          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl md:rounded-3xl p-5 md:p-8 lg:p-12 border border-red-200">
            <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="w-12 md:w-16 h-12 md:h-16 bg-red-600 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-error-warning-line text-2xl md:text-4xl text-white"></i>
              </div>
              <div>
                <h3 className="text-lg md:text-3xl font-black text-red-800">기존 자석식 수도미터기의 문제점</h3>
                <p className="text-red-600 text-xs md:text-base mt-1 font-semibold">현재 사용 중인 자석식 수도미터기의 구조적 취약점</p>
              </div>
            </div>

            <div className="grid lg:grid-cols-2 gap-6 md:gap-8 items-start">
              {/* 문제점 리스트 */}
              <div className="space-y-3 md:space-y-4">
                {safeIssues.map((issue, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 md:gap-4 bg-white rounded-xl p-4 md:p-6 shadow-sm border border-red-100 hover:shadow-md transition-shadow"
                  >
                    <div className="w-10 md:w-12 h-10 md:h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${issue.icon} text-lg md:text-2xl text-red-600`}></i>
                    </div>
                    <p className="text-gray-700 text-sm md:text-base leading-relaxed font-medium">{issue.text}</p>
                  </div>
                ))}
              </div>

              {/* 이미지 - 자석식 문제 시각화 */}
              <div className="space-y-4 md:space-y-6">
                <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-red-100">
                  <div className="w-full h-[200px] md:h-[300px]">
                    <img
                      src="https://public.readdy.ai/ai/img_res/d81be316dc2a8e5d12b5ff27059a6cc2.jpg"
                      alt="자석식 수도미터기 구조 문제점"
                      title="기존 자석식 수도미터기의 구조적 취약점"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-4 md:p-5 bg-red-50">
                    <p className="text-sm md:text-base text-red-700 font-bold text-center">
                      <i className="ri-information-line mr-1"></i>
                      외부 자석에 의한 리드 스위치 오작동 및 부정사용 취약
                    </p>
                  </div>
                </div>

                {/* 핵심 문제 요약 */}
                <div className="bg-red-600 rounded-2xl p-5 md:p-7 text-white">
                  <h4 className="font-black text-lg md:text-xl mb-3 md:mb-4 flex items-center gap-2">
                    <i className="ri-alarm-warning-line text-xl md:text-2xl"></i>
                    핵심 문제
                  </h4>
                  <ul className="space-y-2 md:space-y-3 text-sm md:text-base">
                    <li className="flex items-start gap-2">
                      <i className="ri-close-circle-fill text-red-200 mt-0.5 flex-shrink-0 text-lg"></i>
                      <span className="font-medium">외부 자석으로 계량기 조작(부정사용) 가능</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-circle-fill text-red-200 mt-0.5 flex-shrink-0 text-lg"></i>
                      <span className="font-medium">MR 센서가 외부 자기장에 취약</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-circle-fill text-red-200 mt-0.5 flex-shrink-0 text-lg"></i>
                      <span className="font-medium">유량 계산 중지로 정확한 계량 불가</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-circle-fill text-red-200 mt-0.5 flex-shrink-0 text-lg"></i>
                      <span className="font-medium">연간 수십억 원의 수도 요금 유출</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 광센서 수도미터의 해결책 */}
        <div className="mb-8 md:mb-12">
          <div className="bg-gradient-to-br from-teal-600 to-[#0a3d4f] rounded-2xl md:rounded-3xl p-5 md:p-7 lg:p-9 text-white shadow-2xl">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-7">
              <div className="w-10 md:w-14 h-10 md:h-14 bg-white/20 rounded-xl flex items-center justify-center">
                <i className="ri-lightbulb-flash-line text-xl md:text-3xl text-teal-200"></i>
              </div>
              <h3 className="text-xl md:text-3xl font-black">광센서 수도미터의 해결책</h3>
            </div>

            {/* 스크린샷 이미지 */}
            <div className="bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-2xl mb-5 md:mb-7">
              <img
                src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/e4d2d166ea3b138cc74377426ae9d4a1.png"
                alt="광센서 수도미터 해결책"
                title="Why Optical Sensing Digital Water Meter - 광센서 수도미터의 장점"
                className="w-full h-auto object-contain"
              />
            </div>

            {/* 핵심 장점 */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4">
                <div className="flex items-center gap-2 mb-1 md:mb-2">
                  <i className="ri-check-double-line text-teal-300 text-lg"></i>
                  <span className="font-bold text-sm md:text-base">부정사용 원천 차단</span>
                </div>
                <p className="text-xs md:text-sm text-teal-200 font-medium">자석 조작 불가능한 광학 방식</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4">
                <div className="flex items-center gap-2 mb-1 md:mb-2">
                  <i className="ri-check-double-line text-teal-300 text-lg"></i>
                  <span className="font-bold text-sm md:text-base">99.9% 정확도</span>
                </div>
                <p className="text-xs md:text-sm text-teal-200 font-medium">광학 센서 기반 정밀 측정</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4">
                <div className="flex items-center gap-2 mb-1 md:mb-2">
                  <i className="ri-check-double-line text-teal-300 text-lg"></i>
                  <span className="font-bold text-sm md:text-base">납 성분 제로</span>
                </div>
                <p className="text-xs md:text-sm text-teal-200 font-medium">스테인리스 재질 사용</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4">
                <div className="flex items-center gap-2 mb-1 md:mb-2">
                  <i className="ri-check-double-line text-teal-300 text-lg"></i>
                  <span className="font-bold text-sm md:text-base">IoT 실시간 연동</span>
                </div>
                <p className="text-xs md:text-sm text-teal-200 font-medium">원격 모니터링 및 관리</p>
              </div>
            </div>
          </div>
        </div>

        {/* 스마트디지털 선불형 수도계량기 */}
        <div className="mb-12 md:mb-16">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl md:rounded-3xl p-6 md:p-9 lg:p-11 border border-gray-200 shadow-lg">
            <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="w-12 md:w-14 h-12 md:h-14 bg-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-water-flash-line text-2xl md:text-3xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-3xl font-black text-gray-900">스마트디지털 선불형 수도계량기</h3>
                <p className="text-gray-600 text-sm md:text-base mt-1 font-semibold">Smart Digital Prepaid Water Meter</p>
              </div>
            </div>

            {/* 제품 진열 이미지 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-xl border border-gray-100 mb-6">
              <div className="w-full h-[280px] sm:h-[380px] md:h-[500px] flex items-center justify-center bg-gray-50 p-2 sm:p-4">
                <img
                  src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/ba7c8b8e8311fdbbc063802084478f45.png"
                  alt="디지털 수도미터 제품 진열"
                  title="로보에셋그리드 디지털 수도미터 제품 라인업"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-xl border border-gray-100">
              <div className="w-full h-[280px] sm:h-[380px] md:h-[500px] flex items-center justify-center bg-gray-50 p-2 sm:p-4">
                <img
                  src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/0ca813b0f3dfb2c032ae3008e7e79eff.png"
                  alt="스마트디지털 선불형 수도계량기"
                  title="로보에셋그리드 스마트디지털 선불형 수도계량기 제품"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-bank-card-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">선불 충전 방식</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-smartphone-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">스마트폰 연동</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-shield-check-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">부정사용 방지</p>
              </div>
              <div className="bg-teal-50 rounded-xl p-3 md:p-4 text-center flex flex-col items-center justify-center">
                <i className="ri-line-chart-line text-4xl md:text-5xl text-teal-600 mb-2"></i>
                <p className="text-base md:text-lg font-bold text-gray-800">실시간 사용량 확인</p>
              </div>
            </div>
          </div>
        </div>

        {/* 수도미터기 발전 단계 */}
        <div className="mb-12 md:mb-16">
          <h3 className="text-xl md:text-3xl font-black text-gray-900 text-center mb-6 md:mb-9">수도미터기 발전 단계</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 items-center">
            {[
              { title: '기계식 미터기', icon: 'ri-settings-3-line' },
              { title: '전자식 미터기', icon: 'ri-cpu-line' },
              { title: '블루투스', icon: 'ri-bluetooth-line' },
              { title: '복합 결합형', icon: 'ri-stack-line' }
            ].map((step, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="bg-teal-600 text-white rounded-xl px-3 md:px-7 py-3 md:py-5 shadow-lg hover:shadow-xl transition-shadow w-full">
                  <div className="flex items-center justify-center gap-1.5 md:gap-3">
                    <i className={`${step.icon} text-base md:text-3xl`}></i>
                    <span className="font-bold text-xs md:text-lg whitespace-nowrap">{step.title}</span>
                  </div>
                </div>
                {index < 3 && (
                  <i className="ri-arrow-down-line md:hidden text-xl text-teal-600 my-1.5"></i>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* OIML 기준 변경 */}
        <div className="bg-teal-50 rounded-2xl p-6 md:p-9 lg:p-13">
          <div className="flex items-start gap-4 md:gap-5">
            <div className="w-12 md:w-14 h-12 md:h-14 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-file-list-3-line text-2xl md:text-3xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-3 md:mb-4">국제 기준 변경</h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed font-medium">
                한국에서도 <strong className="text-teal-600">2019년 1월 1일</strong>부터 국제법정계량기구(OIML)에서 정하는 기준으로 수도미터기 제조 조건이 변경되었습니다. 이에 따라 광학 센싱 기반의 차세대 수도미터기로의 전환이 필수적입니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
